import { render, staticRenderFns } from "./Seguros-venta-y-asesoria-profesionales.vue?vue&type=template&id=6ca33d22&scoped=true&"
import script from "./Seguros-venta-y-asesoria-profesionales.vue?vue&type=script&lang=js&"
export * from "./Seguros-venta-y-asesoria-profesionales.vue?vue&type=script&lang=js&"
import style0 from "./Seguros-venta-y-asesoria-profesionales.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Seguros-venta-y-asesoria-profesionales.vue?vue&type=style&index=1&id=6ca33d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca33d22",
  null
  
)

export default component.exports